var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"overflow-auto",attrs:{"elevation":"0"}},[_c('v-expansion-panels',{attrs:{"disabled":_vm.loading,"multiple":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }